import { Box, Modal } from "@mui/material";
import loader from "assets/images/loader.gif";

const Loader = (props) => {
  const style = {
    outline: "none",
  };
  return (
    <Box>
      {props.loading ? (
        <Modal open>
          <Box className="loader_loading" sx={style}>
            <figure>
              <img src={loader} alt="loading" />
            </figure>
          </Box>
        </Modal>
      ) : (
        ""
      )}
    </Box>
  );
};

export default Loader;
